import minebikers from "../minebikerstext.png";
import mcc from "../mcctext.jpg";

export default function InstagramButton() {

  return (
    <div style={{justifyContent: "center", alignItems: "center", display: "flex", flexDirection: "column", marginTop: "2%", marginLeft: "5%"}}>
        <img src={minebikers} alt="minebikers text" />
       
        <a href="https://www.instagram.com/minebikers_mcc/">
      Instagramissa
        </a>
    <img style={{marginTop: "2%"}} src={mcc} alt="mcc text" />
    </div>
  );
}